// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__NnzRa","photoBlock":"Message_photoBlock__sh6ln"};